module.exports = __webpack_public_path__ + "static/media/experience.e6bb5cc7.svg";